export default __webpack_public_path__ + "static/media/trash.99a777b4.svg";